import { Component } from "@angular/core";
import { FieldArrayType } from "@ngx-formly/core";

@Component({
    selector: "formly-repeat-section",
    template: `
        <div *ngFor="let field of field.fieldGroup; let i = index" class="flex flex-row items-center">
            <formly-field class="col" [field]="field"></formly-field>
            <div class="flex-none ml-4 mr-4 mt-2">
                <button mat-button (click)="remove(i)">Remove</button>
            </div>
        </div>
        <button mat-button (click)="add()">{{ to.addText }}</button>
    `,
    styleUrls: ["tabs.type.scss"],
})
export class RepeatTypeComponent extends FieldArrayType {}
